import { render, staticRenderFns } from "./roads-index.vue?vue&type=template&id=8cc8f8a8"
import script from "./roads-index.vue?vue&type=script&lang=js"
export * from "./roads-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports